<p-badge
  [badgeSize]="badgeSize"
  [value]="value"
  [severity]="badgeSeverity"
  [styleClass]="cssClass"
  [badgeDisabled]="badgeDisabled"
></p-badge>
